import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconDocLandscape(props: SvgIconProps) {
  return (
    <SVGIcon width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1 9H10C10.5523 9 11 8.55228 11 8V1H11.5C11.7761 1 12 1.22386 12 1.5V8C12 9.10457 11.1046 10 10 10H1.5C1.22386 10 1 9.77614 1 9.5V9Z"
        fill="currentColor"
      />
      <path
        d="M0 0.5C0 0.223858 0.223858 0 0.5 0L9.5 0C9.77614 0 10 0.223858 10 0.5V7.5C10 7.77614 9.77614 8 9.5 8H0.5C0.223858 8 0 7.77614 0 7.5L0 0.5Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
